module.exports = __webpack_public_path__ + "static/img/pic-04.2550f09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic-04.png
// module id = WrAD
// module chunks = 1